import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ibcartao.css';
import Loading from "./components/loading"
import { sendEvent, CNPJ_API_URL, LEAD_API_URL } from './Config';
import LoadingSpinner from './components/LoadingSpinner';
import Footer from './components/Footer';

function isAndroid() {
    return /Android/i.test(navigator.userAgent);
}

function buildChromeIntentUrl(url) {
    try {
        const u = new URL(url);
        const scheme = u.protocol.replace(':', '');
        const fallback = encodeURIComponent(url);
        return `intent://${u.host}${u.pathname}${u.search}${u.hash}#Intent;scheme=${scheme};action=android.intent.action.VIEW;package=com.android.chrome;S.browser_fallback_url=${fallback};end`;
    } catch (e) {
        return url;
    }
}

const ViewPDFDesktop = function () {
    const navigate = useNavigate();
    const enableNotificationsRef = useRef(null);
    const leadIdRef = useRef(localStorage.getItem("lead_id"));
    const [showModal, setShowModal] = useState(1);
    const hasLoadedFirstTime = useRef(false);
    const [nifData, setNIFData] = useState(null);
    const nif = useRef();

    const pdfUrl = `${LEAD_API_URL}/signup/init?leadId=${encodeURIComponent(leadIdRef.current)}&lang=pt`;
    const pdfHref = isAndroid() ? buildChromeIntentUrl(pdfUrl) : pdfUrl;

    useEffect(() => {
        nif.current = localStorage.getItem("nif");

        if (!nif.current) {
            navigate("/")
            return;
        }

        const nifDataStorage = localStorage.getItem(`${nif.current}-data`);

        if (!nifDataStorage) {
            loadNIFData();
        } else {
            setNIFData(JSON.parse(nifDataStorage));
            setShowModal(0);
        }

        sendEvent(leadIdRef.current ?? false, "view-pdf-desktop");

        return () => {
            //clearInterval(intervalId);
        };
    }, []);

    async function loadNIFData() {
        try {
            const res = await fetch(`${LEAD_API_URL}/onboarding/es/cif/${nif.current}`);

            if (!res.ok) {
                if (res.status === 429) {
                    throw new Error('Muitas requisições. Tente novamente mais tarde.');
                }

                throw new Error(`Erro HTTP: ${res.status}`);
            }

            const json = await res.json();

            console.log(json);

            if (json?.empresas?.[0]) {
                localStorage.setItem(`${nif.current}-data`, JSON.stringify(json?.empresas[0]));
                setNIFData(json?.empresas[0]);
            }
        } catch (e) {
            console.error(e.message);
        } finally {
            setShowModal(0);
        }
    }

    const handleFormSubmit = async (e) => {
        e.preventDefault();
    }

    console.log(nifData);

    return <>
        {showModal == 1 ? (<LoadingSpinner />) : ''}
        {showModal == 2 ? (<LoadingSpinner texto={"Generando la visualización en PDF"} />) : ''}
        <div className='header flex items-center'>
            <div className='content flex items-center gap-x-4'>
                <div className='flex items-center w-auto border-r pr-4'>
                    <img src='/assets/img/logo-white.svg?t' className='logo' />
                </div>
                <div className='flex-1'>
                    <span className='subtitle'>Instituto de Crédito Oficial</span>
                </div>
            </div>
        </div>
        <div className="steps mt-5 flex gap-x-2">
            <div className='flex-1 check'></div>
            <div className='flex-1 check'></div>
            <div className='flex-1 check'></div>
            <div className='flex-1 check'></div>
            <div className='flex-1 check'></div>
            <div className='flex-1 check'></div>
        </div>
        <div className='container'>
            <form onSubmit={handleFormSubmit}>
                <div className='content mt-8'>
                    <h1>¡Todo listo! La simulación del ICO para su empresa ya se ha completado.</h1>
                    <p className='mt-6 separator-bottom pb-5 mb-5'>El resultado de su simulación está disponible en PDF. Consulte los detalles a continuación.</p>
                    <div className='flex flex-col gap-1 separator-bottom pb-5'>
                        {!nifData && <><div>CIF:</div>
                            <strong>{nif.current}</strong></>}
                        {nifData && <>
                            {nifData.rs && <>
                                <div className="pt-1">Razón Social:</div>
                                <strong>{nifData.rs}</strong>
                            </>}
                            {nifData?.dir && <>
                                <div className="pt-1">Dirección:</div>
                                <div className='flex'>
                                    <strong>{nifData.dir} - {nifData.p}</strong>
                                </div>
                            </>}
                            {nifData?.s && <>
                                <div className="pt-1">Propósito Corporativo:</div>
                                <div className='flex gap-x-2'>
                                    <strong>{nifData.s}</strong>
                                </div>
                            </>}
                        </>}
                        <div className="pt-1">Categoría simulada:</div>
                        <strong>De 500 mil € a 4,5 millones €</strong>
                        <div className="pt-1">Plazo de pago:</div>
                        <strong>Hasta 30 años</strong>
                    </div>
                    <div className="pt-4">Consulte el PDF a continuación para ver las condiciones y las opciones de pago disponibles para su empresa.</div>
                    <a href={`${pdfHref}`} onClick={async (e) => {
                        if (hasLoadedFirstTime.current == 0) {
                            hasLoadedFirstTime.current = 1;
                            setShowModal(2);

                            setTimeout(() => {
                                setShowModal(0);
                            }, 3 * 1000);
                        }

                        localStorage.setItem("utm_source", "");

                        try {
                            await sendEvent(leadIdRef.current ?? false, "view-pdf-desktop-click");
                        } catch (e) {

                        }
                    }} className="primary w-full mt-8">
                        Ver PDF
                    </a>
                </div>
            </form>
        </div>
    </>
}

export default ViewPDFDesktop;